// extracted by mini-css-extract-plugin
export default {"imageCard":"image-card--imageCard","imageCard_Image":"image-card--imageCard_Image","imageCard_Heading":"image-card--imageCard_Heading"};